import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/products/ProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/shop/ShopFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
